import { useScanDataSubmittedTransactionsStoreLevelDetailsQuery } from '@occc/graphql';
import {
  usePaginatedQuery,
  PaginationInfo,
  PaginationHandler,
} from '@occc-app/hooks/usePaginatedQuery';

type UseScanDataSubmittedTransactionsStoreLevelDetailsParams = {
  submissionDateEquals: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  search?: string;
};

export const useScanDataSubmittedTransactionsStoreLevelDetails = ({
  submissionDateEquals,
  paginationInfo,
  onPageChange,
  search,
}: UseScanDataSubmittedTransactionsStoreLevelDetailsParams) => {
  return usePaginatedQuery(
    useScanDataSubmittedTransactionsStoreLevelDetailsQuery,
    'scanDataSubmittedTransactionsStoreLevelDetails.pageInfo',
    undefined,
    {
      variables: {
        filter: {
          submissionDateEquals,
          siteAccountSubmitterSearch: search,
        },
      },
    },
    paginationInfo,
    onPageChange,
  );
};
